import React from 'react';

function GenericNotFound(props) {
    return (
        <div style={{height: '100%', width: '100%'}}>
            <div className="centered">
                <div style={{fontSize: 14, lineSpacing: 1.6, textAlign: 'center', justifyContent: 'center', maxWidth: 300, lineHeight: 1.6}} >{props.msg}</div>
            </div>
            
        </div>
    );
}

export default GenericNotFound;